/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateBatchBidvVADto } from '../models/CreateBatchBidvVADto';
import type { CreateBatchBidvVAEntity } from '../models/CreateBatchBidvVAEntity';
import type { CreateBidvVAByPrefixDto } from '../models/CreateBidvVAByPrefixDto';
import type { CreateBidvVAEntity } from '../models/CreateBidvVAEntity';
import type { DeleteBidvVAEntity } from '../models/DeleteBidvVAEntity';
import type { DetailBidvVAEntity } from '../models/DetailBidvVAEntity';
import type { GenerateBatchBidvVaQrDto } from '../models/GenerateBatchBidvVaQrDto';
import type { GenerateBatchBidvVaQrEntity } from '../models/GenerateBatchBidvVaQrEntity';
import type { GenQrBidvEntity } from '../models/GenQrBidvEntity';
import type { GenQrBidvVADto } from '../models/GenQrBidvVADto';
import type { GenQrBidvVAEntity } from '../models/GenQrBidvVAEntity';
import type { InquiryBidvVAEntity } from '../models/InquiryBidvVAEntity';
import type { ListBidvVAEntity } from '../models/ListBidvVAEntity';
import type { SyncTransactionsBidvVAEntity } from '../models/SyncTransactionsBidvVAEntity';
import type { UpdateBidvVADto } from '../models/UpdateBidvVADto';
import type { UpdateBidvVAEntity } from '../models/UpdateBidvVAEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvVirtualAccountService {
  /**
   * Lấy danh sách tài khoản định danh BIDV
   * Lấy danh sách VA theo phạm vi người dùng.
   * @param companyId ID công ty cần lọc. Merchant chỉ được chọn công ty của mình.
   * @param search Từ khóa tìm kiếm theo mã VA đầy đủ (vaPrefix + payerId/endCode), payerId, tên người nộp hoặc tên VA.
   * @param status Lọc VA đang hoạt động hoặc đã xóa mềm.
   * @param isUserLinked Chỉ lọc VA đã liên kết với User OTBiz hoặc VA của Merchant.
   * @param page Số trang cần lấy, bắt đầu từ 1.
   * @param limit Số lượng tài khoản định danh trên mỗi trang.
   * @returns ListBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerListVAs(
    companyId?: string,
    search?: string,
    status: 'ACTIVE' | 'DELETED' = 'ACTIVE',
    isUserLinked?: string,
    page: number = 1,
    limit: number = 20,
  ): CancelablePromise<ListBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv-va',
      query: {
        companyId: companyId,
        search: search,
        status: status,
        isUserLinked: isUserLinked,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Lấy chi tiết tài khoản định danh BIDV
   * Lấy chi tiết VA theo ID bản ghi.
   * @param id ID bản ghi tài khoản định danh BIDV
   * @returns DetailBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerDetailVa(
    id: string,
  ): CancelablePromise<DetailBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv-va/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * Tạo tài khoản định danh BIDV mới
   * Tạo một VA mới cho company theo prefix.
   * @param vaPrefix
   * @param requestBody
   * @returns CreateBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerCreateVa(
    vaPrefix: string,
    requestBody: CreateBidvVAByPrefixDto,
  ): CancelablePromise<CreateBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}',
      path: {
        vaPrefix: vaPrefix,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Tạo hàng loạt tài khoản định danh BIDV
   * Tạo nhiều VA theo cùng prefix.
   * @param vaPrefix
   * @param requestBody
   * @returns CreateBatchBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerCreateBatchVa(
    vaPrefix: string,
    requestBody: CreateBatchBidvVADto,
  ): CancelablePromise<CreateBatchBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/batch',
      path: {
        vaPrefix: vaPrefix,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cập nhật tài khoản định danh BIDV
   * Cập nhật thông tin VA theo prefix và endCode.
   * @param vaPrefix VA Prefix
   * @param endCode End Code / Payer ID
   * @param requestBody
   * @returns UpdateBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerUpdateVa(
    vaPrefix: string,
    endCode: string,
    requestBody: UpdateBidvVADto,
  ): CancelablePromise<UpdateBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Xóa tài khoản định danh BIDV
   * Xóa mềm VA theo prefix và endCode.
   * @param vaPrefix VA Prefix
   * @param endCode End Code / Payer ID
   * @returns DeleteBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerDeleteVa(
    vaPrefix: string,
    endCode: string,
  ): CancelablePromise<DeleteBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
    });
  }

  /**
   * Tạo hàng loạt mã QR BIDV cho tài khoản định danh
   * Tạo mã QR cho nhiều VA theo cùng prefix.
   * @param vaPrefix
   * @param requestBody
   * @returns GenerateBatchBidvVaQrEntity
   * @throws ApiError
   */
  public static bidvVaControllerGenerateBatchQr(
    vaPrefix: string,
    requestBody: GenerateBatchBidvVaQrDto,
  ): CancelablePromise<GenerateBatchBidvVaQrEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/batch/qr',
      path: {
        vaPrefix: vaPrefix,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Vấn tin trạng thái giao dịch của tài khoản định danh BIDV
   * Có thể truyền startDate và endDate dưới dạng ISO 8601 có múi giờ. Nếu có startDate thì bắt buộc có endDate; endDate phải trong 30 ngày gần nhất và không ở tương lai. Khi truyền cả hai, endDate phải bằng hoặc sau startDate và khoảng cách tối đa 60 ngày. Không truyền ngày sẽ không gửi tham số ngày cho BIDV.
   * @param vaPrefix VA Prefix
   * @param endCode End Code / Payer ID
   * @param startDate Thời điểm bắt đầu vấn tin theo ISO 8601, có giờ và múi giờ. Nếu truyền trường này thì bắt buộc truyền endDate; khoảng thời gian tối đa 60 ngày.
   * @param endDate Thời điểm kết thúc vấn tin theo ISO 8601, có giờ và múi giờ; chỉ nhận thời điểm trong 30 ngày gần nhất và không ở tương lai.
   * @returns InquiryBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerInquiry(
    vaPrefix: string,
    endCode: string,
    startDate?: string,
    endDate?: string,
  ): CancelablePromise<InquiryBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/inquiry',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      query: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  }

  /**
   * Đồng bộ giao dịch VA của người dùng hệ thống từ kết quả vấn tin BIDV
   * Đồng bộ giao dịch Credit hợp lệ từ kết quả vấn tin BIDV.
   * @param vaPrefix VA Prefix
   * @param endCode End Code / Payer ID
   * @param startDate Thời điểm bắt đầu vấn tin theo ISO 8601, có giờ và múi giờ. Nếu truyền trường này thì bắt buộc truyền endDate; khoảng thời gian tối đa 60 ngày.
   * @param endDate Thời điểm kết thúc vấn tin theo ISO 8601, có giờ và múi giờ; chỉ nhận thời điểm trong 30 ngày gần nhất và không ở tương lai.
   * @returns SyncTransactionsBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerSyncTransactions(
    vaPrefix: string,
    endCode: string,
    startDate?: string,
    endDate?: string,
  ): CancelablePromise<SyncTransactionsBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/sync-transactions',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      query: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  }

  /**
   * Tạo mã QR cho tài khoản định danh BIDV
   * Tạo mã QR cho VA theo yêu cầu thanh toán.
   * @param vaPrefix VA Prefix from Company
   * @param endCode End Code / Payer ID
   * @param requestBody
   * @returns GenQrBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerGenQr(
    vaPrefix: string,
    endCode: string,
    requestBody?: GenQrBidvVADto,
  ): CancelablePromise<GenQrBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/qr',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Lấy hình ảnh QR của tài khoản định danh BIDV
   * Lấy ảnh QR đã lưu của VA.
   * @param vaPrefix VA Prefix from Company
   * @param endCode End Code / Payer ID of the Virtual Account
   * @returns GenQrBidvVAEntity
   * @throws ApiError
   */
  public static bidvVaControllerGetQr(
    vaPrefix: string,
    endCode: string,
  ): CancelablePromise<GenQrBidvVAEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/qr',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
    });
  }

  /**
   * Lấy hình VietQR BIDV kèm số tiền thanh toán
   * Tạo ảnh VietQR theo số tiền yêu cầu.
   * @param vaPrefix VA Prefix from Company
   * @param endCode End Code / Payer ID of the Virtual Account
   * @param amount QR payment amount
   * @returns GenQrBidvEntity
   * @throws ApiError
   */
  public static bidvVaControllerGetQrWithAmount(
    vaPrefix: string,
    endCode: string,
    amount: string,
  ): CancelablePromise<GenQrBidvEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/bidv-va/{vaPrefix}/{endCode}/qr-with-amount',
      path: {
        vaPrefix: vaPrefix,
        endCode: endCode,
      },
      query: {
        amount: amount,
      },
    });
  }
}
